<template>
  <vwc-button
    :label="label"
    appearance="filled"
    :layout="layout"
    :disabled="isLeaving"
    @click="leaveMeeting(endForAll, stopRecordingFlag)"
  ></vwc-button>
</template>

<script lang="ts">
import logger from '@/services/logging/logger';
import { LOG_CATEGORIES } from '@/services/logging/log-categories';
import { mapActions, mapGetters, mapState } from 'vuex';
import { ANALYTICS } from '@/consts/global-consts';
import analytics from '@/services/analytics-service';

export default {
  name: 'EndMeetingButton',

  props: {
    shouldCloseWindow: { type: Boolean, default: true },
    layout: { type: String, default: 'outlined' },
    label: { type: String, required: true },
    endForAll: { type: Boolean, required: true },
    stopRecordingFlag: { type: Boolean, default: true }
  },

  data() {
    return {
      isLeaving: false
    };
  },

  computed: {
    ...mapGetters(['isSessionOwner', 'isMobileWebMode']),
    ...mapGetters('recordings', ['isRecording', 'isRecordingOwner']),
    ...mapState([
      'roomDetails',
      'myParticipantId',
      'isEndMeetingDialogVisible'
    ]),
    ...mapState('recordings', ['recordingOwner'])
  },

  methods: {
    ...mapActions(['setIsEndMeetingDialogVisible', 'leaveSession']),
    ...mapActions('recordings', ['stopRecording']),

    async leaveMeeting(endForAll, stopRecordingFlag) {
      this.isLeaving = true;
      if (
        (this.isRecordingOwner || this.isSessionOwner) &&
        this.isRecording &&
        stopRecordingFlag &&
        !this.roomDetails.isAutoRecorded
      ) {
        await this.stopRecording();
      }
      try {
        await this.leaveSession({
          endForAll,
          closeWindow: this.shouldCloseWindow
        });
        this.modalAnalytic(
          this.isSessionOwner ? 'End meeting' : 'Leave meeting'
        );
      } catch (err) {
        logger.log('failed to leave session', { err });
        this.isLeaving = false;
      }
      if (endForAll) {
        logger.log('end-for-all-button-clicked', LOG_CATEGORIES.UI_INTERACTION);
      } else {
        logger.log(
          'leave-meeting-button-clicked',
          LOG_CATEGORIES.UI_INTERACTION
        );
      }
    },

    modalAnalytic(selectedOption) {
      analytics.trackEvent(ANALYTICS.END_OR_LEAVE_MEETING_MODAL, {
        'Modal Type': this.isSessionOwner
          ? 'End meeting modal'
          : 'Leave meeting modal',
        'Selected option': selectedOption
      });
    }
  }
};
</script>

<style scoped></style>
